import * as React from 'react';
import Helmet from 'react-helmet';
import { isCdkEnvironment } from '../utils/constants';

type Props = {
  description?: string;
  lang?: string;
  title: string;
};

export const DocumentHead = ({ description, lang = 'en', title }: Props) => {
  const faviconHref = isCdkEnvironment
    ? '/favicon/cdk/favicon.svg'
    : '/favicon/covideo/favicon.ico';

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={'%s'}
      meta={[
        {
          name: `description`,
          content: description,
        },
      ]}
      link={[
        {
          rel: 'icon',
          type: 'image/x-icon',
          href: faviconHref,
        },
      ]}
    />
  );
};
